import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

// Linha do tempo de avaliações (somente leitura) — mostra o histórico de
// consultas registradas pelo admin (treino ou nutrição), numeradas em
// ordem cronológica.
export default function AvaliacaoTimelineAluna({ tabela, alunaId, titulo }) {
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!alunaId) return;
    supabase.from(tabela).select('*').eq('aluna_id', alunaId).order('data')
      .then(({ data }) => { setRegistros(data || []); setLoading(false); });
  }, [alunaId, tabela]);

  const fmtData = (str) => new Date(str + 'T12:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

  if (loading || registros.length === 0) return null;

  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', padding: '28px', marginBottom: '16px' }}>
      <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '16px' }}>{titulo}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {[...registros].reverse().map((reg, i) => (
          <div key={reg.id} style={{ background: 'var(--surface-2)', borderRadius: 'var(--r-btn)', padding: '14px 16px' }}>
            <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--accent)', marginBottom: '6px' }}>Avaliação {registros.length - i} — {fmtData(reg.data)}</div>
            {reg.objetivo && <div style={{ fontSize: '13px', color: 'var(--text)', marginBottom: '3px' }}><strong>Objetivo:</strong> {reg.objetivo}</div>}
            {reg.restricoes && <div style={{ fontSize: '13px', color: 'var(--text)', marginBottom: '3px' }}><strong>Restrições/observações de saúde:</strong> {reg.restricoes}</div>}
            {reg.observacoes && <div style={{ fontSize: '12px', color: 'var(--text-2)' }}>{reg.observacoes}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
